import sectionsSliceListener from "../../sections/redux/sectionsSliceListener";
import windowSliceListener from "../../windows/redux/windowSliceListener";
import sheetsManagerListener from "../../sheet/redux/sheetsManagerListener"


export default [
    windowSliceListener,
    sectionsSliceListener,
    sheetsManagerListener
]